import React, { useEffect, useState } from "react";
import ConfigDB from "../../config";
import {
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

import {
  SubscribeCompany,
  getSubscriptionList,
  profileDetail,
  profileDetailForWeb,
} from "../../services/AuthServices";
import { toast } from "react-toastify";
import Utils from "../../utils";
import moment from "moment";
import MbwayIcon from "../../asset/images/MbwayIcon.svg";
import { useNavigate } from "react-router-dom";
import {
  CreatePaymentMBpay,
  CreatePaymentMultibanco,
  CreatePaymentStripe,
} from "../../services/PaymentServices";
import { authActions } from "../../store";
import { useDispatch } from "react-redux";
import Select from "react-select";
import {
  actionCityList,
  actionCountryList,
  actionStateList,
} from "../../services/CommonService";
import { useTranslation } from "react-i18next";
import StripeIcon from "../../asset/images/stripeIcon.svg";
import { loadStripe } from "@stripe/stripe-js";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import VisaImg from "../../asset/images/visa-img.png";
import MasterImg from "../../asset/images/mastercard.png";
import { Elements } from "@stripe/react-stripe-js";
import MultiBancoIcon from "../../asset/images/Multibanco.png";

const Profile = () => {
  const [profileData, setProfileData] = useState({
    name: "",
    email: "",
  });
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);

  const [profileDatas, setProfileDatas] = useState(null);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  let errorsObj = {
    password: "",
    confirmPassword: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [image, setImage] = useState(null);
  const [subscriptionModal, setSubscriptionModal] = useState(false);
  const [SubscriptionList, setSubscriptionList] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [purchaseModal, setPurchaseModal] = useState(false);
  const [purchaseDetailsModal, setPurchaseDetailsModal] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    amount: "",
    mobileNumber: "",
    email: "",
    description: "",
    type_payment: "mb_way",
  });

  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);

  const [state, setState] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const [address, setAddress] = useState("");
  const [company_registration_number, setCompanyRegistrationNumber] =
    useState("");
  const [purchaseDetailsData, setPurchaseDetailsData] = useState("");

  const [purchaseMessageModal, setPurchaseMessageModal] = useState(false);

  let errorsPicObj = {
    image: "",
  };
  const [errorsPic, setErrorsPic] = useState(errorsPicObj);
  const [loading, setLoading] = useState(false);
  const [amountDetails, setAmountDetails] = useState("");
  const [previewUrlAddress, setPreviewUrlAddress] = useState(null);
  const [imageAddress, setImageAddress] = useState(null);
  const [profilesData, setProfilesData] = useState({
    is_enable_ecommerce_access: "",
  });
  const [vehicleData, setVehicleData] = useState({
    country: "",
    state: "",
    city: "",
  });

  const [stripeDetails, setStripeDetails] = useState("");
  const [stripePromise, setStripePromise] = useState(null);
  const [purchaseStripeModal, setPurchaseStripeModal] = useState(false);
  const [multiBancoDetails, setMultiBancoDetails] = useState("");
  const [purchaseMultiBancoModal, setPurchaseMultiBancoModal] = useState(false);

  useEffect(() => {
    if (stripeDetails?.stripe_publish_key) {
      setStripePromise(loadStripe(stripeDetails.stripe_publish_key));
    }
  }, [stripeDetails]);

  useEffect(
    function () {
      if (companyId?.role_id !== "1") {
        actionCountryList()
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i].id,
                label: response.data[i].name,
              });
            }
            setCountryList(list);
          })
          .catch((err) => {});
      }
    },
    [companyId?.role_id !== "1"],
  );

  useEffect(
    function () {
      if (companyId?.role_id !== "1") {
        if (vehicleData?.country) {
          actionStateList({ country_id: vehicleData?.country })
            .then((response) => {
              response = response.data;
              let list = [];
              for (let i = 0; i < response.data.length; i++) {
                list.push({
                  value: response.data[i].id,
                  label: response.data[i].name,
                });
              }
              setStateList(list);
            })
            .catch((err) => {});
        }
      }
    },
    [vehicleData],
  );

  useEffect(
    function () {
      if (vehicleData?.state) {
        actionCityList({ state_id: vehicleData?.state })
          .then((response) => {
            const cityList = response.data.data.map((city) => ({
              value: city.id,
              label: city.name,
            }));
            setCityList(cityList);
          })
          .catch((err) => {});
      }
    },
    [vehicleData],
  );

  const handlePurchaseDetailsClose = () => {
    setPurchaseDetailsModal(false);
  };

  const handlePurchaseClose = () => {
    setPurchaseModal(false);
  };

  const handlePurchaseSubmit = () => {
    setPurchaseModal(false);
    setPurchaseDetailsModal(true);
  };

  const handlePurchaseMultiBancoMessageClose = () => {
    setPurchaseMultiBancoModal(false);
    // setLoginModal(true);
  };

  const handleStripeSubmit = (e) => {
    e.preventDefault();

    setPurchaseModal(false);

    const amount = isChecked
      ? amountDetails?.yearly_price
      : amountDetails?.monthly_price;

    let data = {
      amount: amount,
      currency: "eur",
    };

    CreatePaymentStripe(data)
      .then((response) => {
        toast.dismiss();
        setStripeDetails(response.data.data);
        setPurchaseStripeModal(true);
      })

      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handlePurchaseMessageClose = () => {
    setPurchaseMessageModal(false);
    fetchProfileData();
  };

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files[0];

    if (selectedFiles) {
      setImage(selectedFiles);
      const imageUrl = URL.createObjectURL(selectedFiles);
      setPreviewUrl(imageUrl);
    }
  };

  const handleFileChangeAddress = (event) => {
    const selectedFiles = event.target.files[0];

    if (selectedFiles) {
      setImageAddress(selectedFiles);
      const imageUrl = URL.createObjectURL(selectedFiles);
      setPreviewUrlAddress(imageUrl);
    }
  };

  const fetchProfileData = async () => {
    try {
      const response = await profileDetailForWeb();
      setProfileDatas(response.data.data);
      setProfileData({
        name: response.data.data.name || "",
        email: response.data.data.email || "",
        zipCode:
          companyId?.role_id !== "1"
            ? response.data.data.company_details.zipcode
            : "",
        address:
          companyId?.role_id !== "1"
            ? response.data.data.company_details.address
            : "",
        company_registration_number:
          companyId?.role_id !== "1"
            ? response.data.data.company_details.company_registration_number
            : "",

        phoneNumber:
          companyId?.role_id !== "1"
            ? response.data.data.company_details.phone_number
            : "",
      });
      setPreviewUrl(response.data.data.profile);
      setPreviewUrlAddress(
        companyId?.role_id !== "1"
          ? response.data.data.company_details.address_proof
          : "",
      );
      setImageAddress(
        companyId?.role_id !== "1"
          ? response.data.data.company_details.address_proof
          : "",
      );
      setImage(response.data.data.profile);
      setZipCode(
        companyId?.role_id !== "1"
          ? response.data.data.company_details.zipcode
          : "",
      );
      setCompanyRegistrationNumber(
        companyId?.role_id !== "1"
          ? response.data.data.company_details.company_registration_number
          : "",
      );
      setAddress(
        companyId?.role_id !== "1"
          ? response.data.data.company_details.address
          : "",
      );

      setPhoneNumber(
        companyId?.role_id !== "1"
          ? response.data.data.company_details.phone_number
          : "",
      );

      setProfilesData({
        is_enable_ecommerce_access:
          companyId?.role_id !== "1"
            ? response?.data?.data?.company_details?.is_enable_ecommerce_access
            : "",
      });

      setVehicleData({
        country:
          companyId?.role_id !== "1"
            ? response.data.data.company_details.country
            : "",
        state:
          companyId?.role_id !== "1"
            ? response.data.data.company_details.state
            : "",
        city:
          companyId?.role_id !== "1"
            ? response.data.data.company_details.city
            : "",
      });
    } catch (err) {
      toast.error(Utils.getErrorMessage(err));
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  function LoadList() {
    getSubscriptionList()
      .then((response) => {
        setSubscriptionList(response.data.data);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }

  const valueChangedHandler = function () {
    setIsChecked(!isChecked);
  };

  // const onSubscription = (e, item) => {
  //   setAmountDetails(item);

  // };

  const onSubscription = (item) => {
    setAmountDetails(item);
    setPurchaseModal(true);
    setSubscriptionModal(false);
  };

  const handleChangeSubscriptionPlan = () => {
    setSubscriptionModal(true);
    LoadList();
  };

  const handleChangeSubscriptionPlanClose = () => {
    setSubscriptionModal(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfileData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateImage = (image) => {
    if (!image) {
      return false;
    }
    const allowedTypes = ["image/jpeg", "image/png"];
    const maxSize = 2 * 1024 * 1024; // 2MB
    return allowedTypes.includes(image.type) && image.size <= maxSize;
  };

  const handleCheckboxChangeProfile = (e) => {
    setProfilesData({
      ...profilesData,
      is_enable_ecommerce_access: e.target.checked ? 1 : 0,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let error = false;
    let errorObj = { ...errorsObj };

    let errorObjPic = { ...errorsPicObj };
    let errorPic = false;

    if (password && password.length < 8) {
      errorObj.password = "Password must be at least 8 characters long.";
      error = true;
    }

    if (confirmPassword && confirmPassword.length < 8) {
      errorObj.confirmPassword = "Password must be at least 8 characters long.";
      error = true;
    } else if (password && password !== confirmPassword) {
      errorObj.confirmPassword = "Passwords do not match!";
      error = true;
    }

    if (!validateImage(image)) {
      errorObjPic.image =
        "Invalid file. Please upload a valid image. Size must be < 2mb";
      errorPic = true;
    }

    setErrors(errorObj);
    if (error) return;

    const formData = new FormData();
    formData.append("files", image);
    formData.append("password", password);
    formData.append("name", profileData.name);
    formData.append("email", profileData.email);

    if (companyId?.role_id !== "1") {
      formData.append("address_proof", imageAddress);
      formData.append("country", vehicleData?.country);
      formData.append("state", vehicleData?.state);
      formData.append("city", vehicleData?.city);
      formData.append("zipcode", zipCode);
      formData.append("phone_number", phoneNumber);
      formData.append("address", address);
      formData.append(
        "company_registration_number",
        company_registration_number,
      );
      formData.append(
        "is_enable_ecommerce_access",
        profilesData?.is_enable_ecommerce_access,
      );
    }

    profileDetail(formData)
      .then((response) => {
        toast.success(response.data.message);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };
  const API_URL = ConfigDB.data.api_url;

  const handleSubmitMBPayPayment = (e) => {
    e.preventDefault();

    setLoading(true);

    const amount = isChecked
      ? amountDetails?.yearly_price
      : amountDetails?.monthly_price;

    let data = {
      amount: amount,
      mobileNumber: purchaseData?.mobileNumber,
      email: purchaseData?.email,
      company_id: companyId?.company_id,
      type_payment: "mb_way",
    };

    CreatePaymentMBpay(data)
      .then((response) => {
        setLoading(false); // Set loading to false

        setPurchaseDetailsData(response.data.data);
        toast.success(response.data.message);
        setPurchaseDetailsModal(false);

        let obj = {
          user_id: profileDatas?.id,
          plan_type: isChecked ? 2 : 1,
          uuid: amountDetails.uuid,
        };
        SubscribeCompany(obj)
          .then((response) => {
            let userData = response?.data?.data;
            if (userData) {
              Utils.setDetail(userData);
              dispatch(authActions.login(userData));
            }
          })
          .catch((error) => {
            toast.error(Utils.getErrorMessage(error));
          });
      })
      .catch((err) => {
        setLoading(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handlePurchaseMUltibancoSubmit = (e, method) => {
    e.preventDefault();

    setPurchaseModal(false);

    const amount = isChecked
      ? amountDetails?.yearly_price
      : amountDetails?.monthly_price;

    let data = {
      amount: amount,
      company_id: companyId?.company_id,
    };

    CreatePaymentMultibanco(data)
      .then((response) => {
        toast.dismiss();
        toast.success(response.data.message);
        setMultiBancoDetails(response.data.data);
        setPurchaseMultiBancoModal(true);
      })

      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="">
                <h1>{t("profile")}</h1>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card card-primary">
                  <Form method={`post`} onSubmit={handleSubmit}>
                    {companyId?.default_user === 1 ? (
                      <>
                        <div className="card-body">
                          <h3 className="">{t("update_profile")}</h3>
                          <div className="row justify-content-start">
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("name")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="name"
                                      name="name"
                                      placeholder={t("enter_name")}
                                      value={profileData?.name}
                                      onChange={handleInputChange}
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("e_mail")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <input
                                      type="email"
                                      className="form-control"
                                      id="email"
                                      name="email"
                                      placeholder={t("enter_email")}
                                      value={profileData?.email}
                                      disabled
                                      onChange={handleInputChange}
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            {companyId?.role_id !== "1" && (
                              <>
                                <div className="col-md-4">
                                  <div className="padding-bottom--24">
                                    <label
                                      htmlFor="country"
                                      className="label-my col-form-label ml-2 Label-my form-label form-label form-label"
                                    >
                                      {t("country")}
                                    </label>

                                    <Select
                                      className="my-select-v"
                                      options={countryList}
                                      value={countryList.find(
                                        (option) =>
                                          option.value ===
                                          Number(vehicleData.country),
                                      )}
                                      onChange={(selectedOption) =>
                                        setVehicleData({
                                          ...vehicleData,
                                          country: selectedOption
                                            ? selectedOption.value
                                            : "",
                                          state: "",
                                          city: "",
                                        })
                                      }
                                      placeholder={t("select_country")}
                                      isClearable
                                      isSearchable
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="padding-bottom--24">
                                    <label
                                      htmlFor="state"
                                      className="col-form-label ml-2 Label-my form-label form-label form-label"
                                    >
                                      {t("district")}
                                    </label>

                                    <Select
                                      className="my-select-v"
                                      options={stateList}
                                      value={stateList.find(
                                        (option) =>
                                          option.value ===
                                          Number(vehicleData.state),
                                      )}
                                      onChange={(selectedOption) =>
                                        setVehicleData({
                                          ...vehicleData,
                                          state: selectedOption
                                            ? selectedOption.value
                                            : "",
                                          city: "",
                                        })
                                      }
                                      placeholder={t("select_state")}
                                      isClearable
                                      isSearchable
                                      isDisabled={!vehicleData.country}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="padding-bottom--24">
                                    <label
                                      htmlFor="city"
                                      className="col-form-label ml-2 Label-my form-label form-label form-label"
                                    >
                                      {t("concelho")}
                                    </label>

                                    <Select
                                      className="my-select-v"
                                      options={cityList}
                                      value={cityList.find(
                                        (option) =>
                                          option.value ===
                                          Number(vehicleData.city),
                                      )}
                                      onChange={(selectedOption) =>
                                        setVehicleData({
                                          ...vehicleData,
                                          city: selectedOption
                                            ? selectedOption.value
                                            : "",
                                        })
                                      }
                                      placeholder={t("select_city")}
                                      isClearable
                                      isSearchable
                                      isDisabled={!vehicleData.state}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="padding-bottom--24">
                                    <label
                                      htmlFor="zipCode"
                                      className="col-form-label ml-2 Label-my form-label form-label form-label"
                                    >
                                      {t("zip_code")}
                                    </label>
                                    <input
                                      type="text"
                                      id="zipCode"
                                      className="form-control input-my input-search"
                                      placeholder={t("enter_zipcode")}
                                      value={zipCode}
                                      onChange={(e) =>
                                        setZipCode(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md-4">
                                  <div className="padding-bottom--24">
                                    <label
                                      htmlFor="phoneNumber"
                                      className="col-form-label ml-2 Label-my form-label form-label form-label"
                                    >
                                      {t("phone_number")}
                                    </label>
                                    <input
                                      type="text"
                                      id="phoneNumber"
                                      className="form-control input-my input-search"
                                      placeholder={t("enter_mobile_number")}
                                      value={phoneNumber}
                                      onChange={(e) =>
                                        setPhoneNumber(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="padding-bottom--24">
                                    <label
                                      htmlFor="company_registration_number"
                                      className="label-my col-form-label ml-2 Label-my form-label form-label form-label"
                                    >
                                      {t("taxpayer_id")}
                                    </label>
                                    <input
                                      type="text"
                                      id="company_registration_number"
                                      className="form-control input-my input-search"
                                      placeholder={t("enter_company_reg_number")}
                                      value={company_registration_number}
                                      onChange={(e) =>
                                        setCompanyRegistrationNumber(
                                          e.target.value,
                                        )
                                      }
                                      disabled // This makes it permanently disabled
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                            {companyId?.role_id !== "1" && (
                              <div className="col-md-12">
                                <div className="padding-bottom--24">
                                  <label
                                    htmlFor="address"
                                    className="label-my col-form-label ml-2 Label-my form-label form-label form-label"
                                  >
                                    {t("address")}
                                  </label>
                                  <textarea
                                    name="address"
                                    className="form-control input-my input-search"
                                    id="address"
                                    cols="30"
                                    rows="2"
                                    placeholder={t("enter_your_address")}
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                  ></textarea>
                                </div>
                              </div>
                            )}
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("password")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <input
                                      type="password"
                                      className="form-control"
                                      id="password"
                                      placeholder={t("enter_new_password")}
                                      value={password}
                                      onChange={(e) =>
                                        setPassword(e.target.value)
                                      }
                                    />
                                  </div>
                                  {errors.password && (
                                    <span className="input-error">
                                      {errors.password}
                                    </span>
                                  )}
                                </div>
                              </FormGroup>
                            </div>
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("confirm_password")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <input
                                      type="password"
                                      className="form-control"
                                      id="confirmPassword"
                                      placeholder={t("confirm_new_password")}
                                      value={confirmPassword}
                                      onChange={(e) =>
                                        setConfirmPassword(e.target.value)
                                      }
                                    />
                                  </div>
                                  {errors.confirmPassword && (
                                    <span className="input-error">
                                      {errors.confirmPassword}
                                    </span>
                                  )}
                                </div>
                              </FormGroup>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-6">
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("profile")}
                              </Label>
                              <div className="avatar-upload">
                                <div className="avatar-edit">
                                  <div className="input-div">
                                    <input
                                      className="inputFile"
                                      type="file"
                                      id="imageUpload"
                                      onChange={handleFileChange}
                                      name="file"
                                      accept=".jpg,.jpeg,.png"
                                    />
                                  </div>
                                  <label htmlFor="imageUpload"></label>
                                </div>
                                <div className="avatar-preview profile-user">
                                  <img
                                    src={previewUrl}
                                    className="preview-image"
                                  />
                                </div>
                              </div>
                            </div>
                            {companyId?.role_id !== "1" ? (
                              <>
                                <div className="col-md-6">
                                  <div className="padding-bottom--24">
                                    <label
                                      htmlFor="address_proof"
                                      className="label-my col-form-label ml-2 Label-my form-label form-label form-label"
                                    >
                                      {t("address_proof")}
                                    </label>
                                    <div className="avatar-upload">
                                      <div className="avatar-edit">
                                        <div className="input-div">
                                          <input
                                            className="inputFile"
                                            type="file"
                                            id="imageUploads"
                                            onChange={handleFileChangeAddress}
                                            name="file"
                                            accept=".jpg,.jpeg,.png"
                                          />
                                        </div>
                                        <label htmlFor="imageUploads"></label>
                                      </div>
                                      <div className="avatar-preview profile-user">
                                        <img
                                          src={previewUrlAddress}
                                          className="preview-image"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>{" "}
                              </>
                            ) : (
                              <div className="col-md-6"></div>
                            )}
                          </div>
                        </div>
                        <div className="container-fluid profile-setting-dev-1">
                          <div className="row">
                            {companyId?.role_id !== "1" ? (
                              <div className="col-lg-6 flex-equal">
                                <div className="card">
                                  <div className="profileHeader">
                                    <h6>{t("subscription_details")}</h6>
                                    <button
                                      type="button"
                                      className="btn btn-primary changeBtn"
                                      onClick={handleChangeSubscriptionPlan}
                                    >
                                      {t("change_plan")}
                                    </button>
                                  </div>
                                  <div className="card-body">
                                    <div className="subscribed-content">
                                      <p>
                                        <strong>{t("subscribed_on")} :</strong>

                                        <span className="date-time-1">
                                          {moment(
                                            profileDatas?.subscription_data
                                              ?.subscribed_on,
                                          ).format("DD/MM/YYYY")}
                                        </span>
                                      </p>
                                    </div>

                                    <div className="subscribed-content">
                                      <p>
                                        <strong>{t("subscribed_end")} :</strong>
                                        <span className="date-time-1">
                                          {moment(
                                            profileDatas?.subscription_data
                                              ?.subscribed_ends,
                                          ).format("DD/MM/YYYY")}
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}

                            <div
                              className={
                                companyId?.role_id !== "1"
                                  ? "col-lg-6 flex-equal"
                                  : "col-lg-12"
                              }
                            >
                              <div className="card">
                                <div className="card-header">
                                  <h6>{t("last_login_details")}</h6>
                                </div>
                                <div className="card-body">
                                  <div className="subscribed-content">
                                    <p>
                                      <strong>{t("last_login_date")}:</strong>
                                      <span className="date-time-1">
                                        {moment(
                                          profileDatas?.last_login_date,
                                        ).format("DD/MM/YYYY HH:mm")}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="card-body">
                          <h3 className="">{t("update_profile")}</h3>
                          <div className="row justify-content-start">
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("name")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="name"
                                      name="name"
                                      placeholder={t("enter_name")}
                                      value={profileData?.name}
                                      onChange={handleInputChange}
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("e_mail")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <input
                                      type="email"
                                      className="form-control"
                                      id="email"
                                      name="email"
                                      placeholder={t("enter_email")}
                                      value={profileData?.email}
                                      disabled
                                      onChange={handleInputChange}
                                    />
                                  </div>
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("password")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <input
                                      type="password"
                                      className="form-control"
                                      id="password"
                                      placeholder={t("enter_new_password")}
                                      value={password}
                                      onChange={(e) =>
                                        setPassword(e.target.value)
                                      }
                                    />
                                  </div>
                                  {errors.password && (
                                    <span className="input-error">
                                      {errors.password}
                                    </span>
                                  )}
                                </div>
                              </FormGroup>
                            </div>
                            <div className="col-md-4">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("confirm_password")}
                                </Label>
                                <div className="col-xl-12">
                                  <div className="input-div">
                                    <input
                                      type="password"
                                      className="form-control"
                                      id="confirmPassword"
                                      placeholder={t("confirm_new_password")}
                                      value={confirmPassword}
                                      onChange={(e) =>
                                        setConfirmPassword(e.target.value)
                                      }
                                    />
                                  </div>
                                  {errors.confirmPassword && (
                                    <span className="input-error">
                                      {errors.confirmPassword}
                                    </span>
                                  )}
                                </div>
                              </FormGroup>
                            </div>

                            <div className="col-md-6">
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                {t("profile")}
                              </Label>
                              <div className="avatar-upload">
                                <div className="avatar-edit">
                                  <div className="input-div">
                                    <input
                                      className="inputFile"
                                      type="file"
                                      id="imageUpload"
                                      onChange={handleFileChange}
                                      name="file"
                                      accept=".jpg,.jpeg,.png"
                                    />
                                  </div>
                                  <label htmlFor="imageUpload"></label>
                                </div>
                                <div className="avatar-preview profile-user">
                                  <img
                                    src={previewUrl}
                                    className="preview-image"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    <div className="card-footer d-flex justify-content-end">
                      <button type="submit" className="btn btn-primary">
                        {t("submit")}
                      </button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Modal isOpen={subscriptionModal} className="modal-dialog modal-xl">
          <ModalBody>
            <button
              type="button"
              className="close"
              onClick={handleChangeSubscriptionPlanClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div className="form">
              <div className="heading"></div>
              <form method={`post`}>
                <div className="heading mb-4">
                  {t("subscription")}
                  <div
                    className={`bootstrap-switch ${
                      isChecked ? "bootstrap-switch-on" : "bootstrap-switch-off"
                    }`}
                    style={{ marginLeft: "10px" }}
                  >
                    <div
                      className="bootstrap-switch-container"
                      onClick={(e) => valueChangedHandler()}
                    >
                      <span
                        className={`bootstrap-switch-handle-on ${
                          isChecked ? "bootstrap-switch-primary" : ""
                        }`}
                      >
                        {t("yearly")}
                      </span>
                      <span className="bootstrap-switch-label">&nbsp;</span>
                      <span
                        className={`bootstrap-switch-handle-off ${
                          !isChecked ? "bootstrap-switch-default" : ""
                        }`}
                      >
                        {t("monthly")}
                      </span>
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.value)}
                        style={{ display: "none" }}
                      />
                    </div>
                  </div>
                </div>

                <div className="padding-bottom--24">
                  <div className="container">
                    <div className="card-deck mb-3  card-deck-custome">
                      {SubscriptionList?.filter(
                        (item) =>
                          item.is_free === 0 &&
                          item.id !=
                            profileDatas.subscription_data?.subscription_id,
                      ).map((item, index) => {
                        return (
                          <div key={index} className="card mb-4 box-shadow">
                            <div className="card-header">
                              <h4 className="my-0 font-weight-normal">
                                {item.name}
                              </h4>
                            </div>
                            <div className="card-body">
                              <h5 className="pricing-card-title">
                                <b>
                                  €
                                  {isChecked
                                    ? item.yearly_price + "/Year"
                                    : item.monthly_price + "/Month"}
                                </b>
                              </h5>
                              <div className="list-unstyled mt-3 mb-4">
                                {item.subscription_desc}
                              </div>
                            </div>
                            <div className="card-footer">
                              <div className="d-flex justify-content-center">
                                <button
                                  className="login-btn"
                                  type="button"
                                  onClick={(e) => onSubscription(item)}
                                >
                                  <span className="text">
                                    {item.is_free ? t("free") : t("purchase")}
                                  </span>
                                  <span className="icon">€</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={purchaseModal}>
          <ModalHeader>{t("payment_method")}</ModalHeader>
          <ModalBody>
            <div
              className="card"
              style={{ borderRadius: "8px", marginBottom: "0px" }}
            >
              <div
                className="card-body"
                style={{ display: "flex", cursor: "pointer" }}
                onClick={handlePurchaseSubmit}
              >
                <img src={MbwayIcon} alt="" style={{ width: "85px" }} />
                <h4 style={{ fontSize: "21px", marginTop: "10px" }}>MBWAY</h4>
              </div>

              <div
                className={`card-body`}
                style={{
                  display: "flex",
                  cursor: "pointer",
                  marginLeft: "-13px",
                }}
                onClick={(e) => handlePurchaseMUltibancoSubmit(e, "MultiBanco")}
              >
                <img src={MultiBancoIcon} alt="" style={{ width: "85px" }} />
                <h4 style={{ fontSize: "21px", marginTop: "10px" }}>
                  MultiBanco
                </h4>
              </div>

              <div
                className={`card-body`}
                style={{
                  display: "flex",
                  cursor: "pointer",
                  marginLeft: "-13px",
                }}
                onClick={(e) => handleStripeSubmit(e, "Stripe")}
              >
                <img
                  src={StripeIcon}
                  alt=""
                  style={{
                    width: "82px",
                    marginRight: "16px",
                    marginLeft: "12px",
                    marginTop: "-16px",
                  }}
                />
                <h4 style={{ fontSize: "21px", marginTop: "10px" }}>Stripe</h4>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={purchaseDetailsModal}>
          <ModalHeader>MBWAY</ModalHeader>
          <Form method={`post`} onSubmit={handleSubmitMBPayPayment}>
            {loading ? (
              <div className="spinner-grow" role="status">
                <span className="visually-hidden">{t("loading")}</span>
              </div>
            ) : (
              <>
                <ModalBody>
                  <div className="row">
                    <div className="col-md-12">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my">
                          {t("mobile_number")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control input-search"
                              type="text"
                              value={purchaseData.mobileNumber}
                              onChange={(e) => {
                                setPurchaseData({
                                  ...purchaseData,
                                  mobileNumber: e.target.value,
                                });
                              }}
                              name={`mobileNumber`}
                              maxLength={9}
                              placeholder={t("mobile_number")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>

                    <div className="col-md-12">
                      <FormGroup>
                        <Label className="col-form-label ml-2 Label-my">
                          {t("e_mail")}
                        </Label>
                        <div className="col-xl-12">
                          <div className="input-div">
                            <input
                              className="form-control input-search"
                              type="text"
                              value={purchaseData.email}
                              onChange={(e) => {
                                setPurchaseData({
                                  ...purchaseData,
                                  email: e.target.value,
                                });
                              }}
                              name={`email`}
                              maxLength={100}
                              placeholder={t("email")}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <button
                    type="button"
                    className="btn btn-block btn-secondary"
                    onClick={handlePurchaseDetailsClose}
                    style={{ width: "100px", marginTop: "10px" }}
                  >
                    {t("close")} <i className="bi bi-x-lg"></i>
                  </button>
                  <button
                    type="submit"
                    className="btn btn-block btn-primary"
                    style={{ width: "100px", marginTop: "10px" }}
                  >
                    {t("submit")} <i className="bi bi-check2"></i>
                  </button>
                </ModalFooter>
              </>
            )}
          </Form>
        </Modal>

        <Modal isOpen={purchaseMessageModal}>
          <ModalHeader className="d-flex justify-content-center">
            {t("payment_successful")}
          </ModalHeader>
          <ModalBody>
            <div
              className="card"
              style={{
                boxShadow: "none",
                marginBottom: "0px",
                textAlign: "center",
              }}
            >
              <div className="card-body">
                <div className="checked">
                  <i className="bi bi-check-lg"></i>
                </div>
                <h5 style={{ fontSize: "11px", marginTop: "12px" }}>
                  {t("your_transaction_id")}: {purchaseDetailsData?.RequestId}
                </h5>
                <p
                  style={{ fontSize: "14px", color: "#000", marginTop: "12px" }}
                >
                  {t("payment_made_successfully")}
                </p>
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="border-0" style={{ marginTop: "-18px" }}>
            <button
              type="button"
              className="btn btn-block btn-payment"
              onClick={handlePurchaseMessageClose}
              style={{ width: "auto", margin: "auto", padding: "5px 12px" }}
            >
              {t("ok")} <i className="bi bi-x-lg"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={purchaseStripeModal}>
          <ModalHeader className="d-flex justify-content-center">
            <img
              src={StripeIcon}
              alt=""
              style={{
                width: "82px",
                marginRight: "16px",
                marginLeft: "12px",
                marginTop: "-16px",
              }}
            />
            Stripe
          </ModalHeader>
          <ModalBody>
            <div
              className="card"
              style={{
                boxShadow: "none",
                marginBottom: "0px",
                textAlign: "center",
              }}
            >
              <div className="card-body">
                <div className="container">
                  <div className="row justify-content-sm-center">
                    <div className="col-xl-12">
                      <div className="card-details card-details-custom">
                        <div className="row">
                          <div className="col-xl-12">
                            <h2 style={{ fontSize: "17px" }}>
                              <strong>{t("price")}:</strong> €{" "}
                              {isChecked
                                ? amountDetails?.yearly_price
                                : amountDetails?.monthly_price}
                            </h2>
                          </div>
                        </div>

                        <div
                          className="row mt-3"
                          style={{ marginBottom: "20px" }}
                        >
                          <div className="col-6 d-flex justify-content-center">
                            <img
                              src={VisaImg}
                              alt="visa"
                              style={{ width: "100px" }}
                            />
                          </div>
                          <div className="col-6 d-flex justify-content-center">
                            <img
                              src={MasterImg}
                              alt="mastercard"
                              style={{ width: "100px" }}
                            />
                          </div>
                        </div>

                        {stripePromise ? (
                          <Elements stripe={stripePromise}>
                            <StripeForm
                              amount={
                                isChecked
                                  ? amountDetails?.yearly_price
                                  : amountDetails?.monthly_price
                              }
                              setPurchaseStripeModal={setPurchaseStripeModal}
                              amountDetails={amountDetails}
                              purchaseData={purchaseData}
                              stripeDetails={stripeDetails}
                              userCompanyId={companyId?.company_id}
                              // companyData={companyData}
                              setSubscriptionModal={setSubscriptionModal}
                              setPurchaseModal={setPurchaseModal}
                              // userUUID={userUUID}
                              isChecked={isChecked}
                              companyId={companyId}
                            />
                          </Elements>
                        ) : (
                          <p>{t("loading_payment_form")}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={purchaseMultiBancoModal}>
          <ModalHeader className="d-flex justify-content-center">
            <img src={MultiBancoIcon} alt="" style={{ width: "66px" }} />
            {t("payment_via_multibanco")}
          </ModalHeader>
          <ModalBody>
            <div
              className="card"
              style={{
                boxShadow: "none",
                marginBottom: "0px",
                textAlign: "center",
              }}
            >
              <div className="card-body">
                <div className="checked"></div>
                <h5 style={{ fontSize: "21px", marginTop: "12px" }}>
                  {t("entity")}: {multiBancoDetails?.entity}
                </h5>
                <h5 style={{ fontSize: "21px", marginTop: "12px" }}>
                  {t("reference")}: {multiBancoDetails?.reference}
                </h5>

                <h5 style={{ fontSize: "21px", marginTop: "12px" }}>
                  {t("amount")}: {multiBancoDetails?.amount} €
                </h5>
              </div>
            </div>
          </ModalBody>
          <ModalFooter className="border-0" style={{ marginTop: "-18px" }}>
            <button
              type="button"
              className="btn btn-block btn-payment"
              onClick={handlePurchaseMultiBancoMessageClose}
              style={{ width: "auto", margin: "auto", padding: "5px 12px" }}
            >
              {t("ok")} <i className="bi bi-x-lg"></i>
            </button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

function StripeForm({
  amount,
  purchaseData,
  amountDetails,
  setPurchaseStripeModal,
  stripeDetails,
  userCompanyId,
  companyData,
  setSubscriptionModal,
  userUUID,
  setPurchaseModal,
  isChecked,
  companyId,
}) {
  const stripe = useStripe();
  const elements = useElements();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) return;

    setIsLoading(true);

    try {
      const cardElement = elements.getElement(CardElement);
      if (!cardElement) throw new Error("CardElement not found");

      const { error: pmError, paymentMethod } =
        await stripe.createPaymentMethod({
          type: "card",
          card: cardElement,
        });

      if (pmError) throw new Error(pmError.message);

      const { paymentIntent, error: confirmError } =
        await stripe.confirmCardPayment(
          stripeDetails?.paymentIntent?.client_secret,
          {
            payment_method: paymentMethod.id,
          },
        );

      if (confirmError) throw new Error(confirmError.message);

      if (paymentIntent?.status !== "succeeded") {
        throw new Error(`Payment failed with status: ${paymentIntent.status}`);
      }

      const paymentBody = {
        amount,
        company_id: userCompanyId,
        description: "",
        mobileNumber: companyId?.company_details?.phone_number || "",
        email: companyId?.email || "",
        paymentIntentId: stripeDetails?.paymentIntent?.id,
        type_payment: "stripe",
      };

      let paymentData;
      try {
        const response = await CreatePaymentMBpay(paymentBody);
        paymentData = response?.data?.data;
      } catch (err) {
        throw new Error("Failed to record payment in system");
      }

      const subscriptionBody = {
        user_id: companyId?.id,
        plan_type: isChecked ? 2 : 1,
        uuid: amountDetails?.uuid,
        payment_id: paymentData?.paymentId,
      };

      try {
        const res = await SubscribeCompany(subscriptionBody);
        const userData = res?.data?.data;

        if (userData) {
          Utils.setDetail(userData);
          dispatch(authActions.login(userData));
          setSubscriptionModal(false);

          // if (amountDetails?.is_free === 1) {
          navigate("/dashboard");
          // } else {
          //   setPurchaseModal(true);
          setPurchaseStripeModal(false);
          // }
          toast.success("Subscription successful!");
        }
      } catch (err) {
        toast.error(Utils.getErrorMessage(err) || "Subscription failed");
        setPurchaseModal(true);
      }
    } catch (err) {
      console.error("Payment error:", err);
      toast.error(err?.message || "Something went wrong during payment");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <CardElement
        options={{
          style: {
            base: {
              fontSize: "16px",
              color: "#424770",
              "::placeholder": { color: "#aab7c4" },
            },
            invalid: { color: "#9e2146" },
          },
        }}
      />
      <div style={{ display: "flex" }}>
        <button
          type="submit"
          className="btn btn-block btn-payment"
          disabled={isLoading}
          style={{
            width: "auto",
            margin: "auto",
            padding: "5px 12px",
            marginTop: "40px",
          }}
        >
          {isLoading ? (
            <>
              <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
            </>
          ) : (
            <>
              <i className="bi bi-stripe"></i> {t("pay")}
            </>
          )}
        </button>

        <button
          type="button"
          className="btn btn-block btn-payment"
          onClick={() => setPurchaseStripeModal(false)}
          style={{
            width: "auto",
            margin: "auto",
            padding: "5px 12px",
            marginTop: "41px",
          }}
        >
          {t("close")} <i className="bi bi-x-lg"></i>
        </button>
      </div>
    </form>
  );
}

export default Profile;
